import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=0f10c420&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=0f10c420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10c420",
  null
  
)

export default component.exports